import { ApolloProvider } from '@apollo/client/react';
import { ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { GlobalStyles } from './components/GlobalStyles';
import { router } from './router';
import { apolloClient } from './utils/apollo';

const App = () => {
  return (
    <ConfigProvider>
      <ApolloProvider client={apolloClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
      <GlobalStyles />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
